import { useState } from 'react';
import api from '../services/api';
import { errMsg, splitList } from '../utils';

type Result = { ok: boolean; text: string } | null;

export default function LifecyclePage() {
  // Joiner
  const [jUser, setJUser] = useState('');
  const [jEmail, setJEmail] = useState('');
  const [jRoles, setJRoles] = useState('');
  const [jGroups, setJGroups] = useState('');
  const [joinerRes, setJoinerRes] = useState<Result>(null);

  // Mover
  const [mId, setMId] = useState('');
  const [mAdd, setMAdd] = useState('');
  const [mRemove, setMRemove] = useState('');
  const [moverRes, setMoverRes] = useState<Result>(null);

  // Leaver
  const [lId, setLId] = useState('');
  const [lReason, setLReason] = useState('termination');
  const [leaverRes, setLeaverRes] = useState<Result>(null);

  const submitJoiner = async () => {
    setJoinerRes(null);
    try {
      const r = await api.post('/lifecycle/joiner', {
        username: jUser,
        email: jEmail || undefined,
        roles: splitList(jRoles),
        groups: splitList(jGroups),
      });
      setJoinerRes({ ok: true, text: `Angelegt: ${r.data.username} (${r.data.userId})` });
    } catch (e) {
      setJoinerRes({ ok: false, text: errMsg(e) });
    }
  };

  const submitMover = async () => {
    setMoverRes(null);
    try {
      await api.post(`/lifecycle/mover/${encodeURIComponent(mId)}`, {
        addRoles: splitList(mAdd),
        removeRoles: splitList(mRemove),
      });
      setMoverRes({ ok: true, text: 'Berechtigungen aktualisiert.' });
    } catch (e) {
      setMoverRes({ ok: false, text: errMsg(e) });
    }
  };

  const submitLeaver = async () => {
    setLeaverRes(null);
    try {
      const r = await api.post(`/lifecycle/leaver/${encodeURIComponent(lId)}`, { reason: lReason });
      setLeaverRes({ ok: true, text: `Deaktiviert; ${r.data.revoked} Rechte entzogen.` });
    } catch (e) {
      setLeaverRes({ ok: false, text: errMsg(e) });
    }
  };

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold text-white">Lifecycle — Joiner / Mover / Leaver</h2>

      <section className="card space-y-3">
        <h3 className="font-medium text-coral">Joiner</h3>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="label">Username</label>
            <input className="input" value={jUser} onChange={(e) => setJUser(e.target.value)} />
          </div>
          <div>
            <label className="label">E-Mail</label>
            <input className="input" value={jEmail} onChange={(e) => setJEmail(e.target.value)} />
          </div>
          <div>
            <label className="label">Rollen (Komma-getrennt)</label>
            <input className="input" value={jRoles} onChange={(e) => setJRoles(e.target.value)} />
          </div>
          <div>
            <label className="label">Gruppen (Komma-getrennt)</label>
            <input className="input" value={jGroups} onChange={(e) => setJGroups(e.target.value)} />
          </div>
        </div>
        <button className="btn-primary" disabled={!jUser} onClick={submitJoiner}>
          Benutzer anlegen
        </button>
        {joinerRes && (
          <p className={joinerRes.ok ? 'text-green-400' : 'text-coral'}>{joinerRes.text}</p>
        )}
      </section>

      <section className="card space-y-3">
        <h3 className="font-medium text-coral">Mover</h3>
        <div>
          <label className="label">Keycloak User-ID</label>
          <input className="input" value={mId} onChange={(e) => setMId(e.target.value)} />
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="label">Rollen hinzufügen</label>
            <input className="input" value={mAdd} onChange={(e) => setMAdd(e.target.value)} />
          </div>
          <div>
            <label className="label">Rollen entfernen</label>
            <input className="input" value={mRemove} onChange={(e) => setMRemove(e.target.value)} />
          </div>
        </div>
        <button className="btn-primary" disabled={!mId} onClick={submitMover}>
          Anwenden
        </button>
        {moverRes && <p className={moverRes.ok ? 'text-green-400' : 'text-coral'}>{moverRes.text}</p>}
      </section>

      <section className="card space-y-3">
        <h3 className="font-medium text-coral">Leaver</h3>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="label">Keycloak User-ID</label>
            <input className="input" value={lId} onChange={(e) => setLId(e.target.value)} />
          </div>
          <div>
            <label className="label">Grund</label>
            <input className="input" value={lReason} onChange={(e) => setLReason(e.target.value)} />
          </div>
        </div>
        <button className="btn-primary" disabled={!lId} onClick={submitLeaver}>
          Deaktivieren &amp; entziehen
        </button>
        {leaverRes && (
          <p className={leaverRes.ok ? 'text-green-400' : 'text-coral'}>{leaverRes.text}</p>
        )}
      </section>
    </div>
  );
}
